export default "__VITE_ASSET__BXuKfHdE__"